const cleanState = {
  eventEndDate: null,
  eventApplicationLogoWebsite: null,
  eventApplicationLogoMobile: null,
};

const initialState = {
  ...cleanState
};

export default (state = initialState, { type, value }) => {
  const valueByType = [
    { type: 'EVENT_END_DATE', value: { ...state, eventEndDate: value }},
    { type: 'EVENT_APPLICATION_LOGO_WEBSITE', value: { ...state, eventApplicationLogoWebsite: value }},
    { type: 'EVENT_APPLICATION_LOGO_MOBILE', value: { ...state, eventApplicationLogoMobile: value }},
  ];

  const selectedType = valueByType.find(item => item.type === type);

  return selectedType ? selectedType.value : state;
};
